import React, { useEffect, useState } from 'react'
import ImageCard from '../../../../components/card/ImageCard'
import { MODEL_OBJECTIVES, MODEL_STATUS, MODEL_TYPES } from '../../../../iaeau/constants/IAEauConstants'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { ShapeIAEauModel } from '../../../../iaeau/shapes/IAEauShapes'
import { Grid, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { compact } from 'lodash'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'

const PREDEFINED_MODEL = -1
const DEFAULT_HORIZON = 10
const DEFAULT_TARRI_PARAMS = { sensibility: 3 }
const DEFAULT_AUGURE_PARAMS = { lineToTake: 'area', nbYearsToTake: 5, average: 7 }
const DEFAULT_ARIMA_PARAMS = {
    p: 0,
    q: 0,
    d: 0,
    P: 0,
    Q: 0,
    D: 0,
    learningMode: false,
    validOnly: false,
    area50: true,
    area90: true,
}
const DEFAULT_SCIKIT_PARAMS = {
    area50: true,
    area70: true,
    area90: true,
}
const DEFAULT_METEO_NAPPE_PARAMS = { dateMode: 'glissant' }

const camelsList = ['A105003001', 'A107020001', 'A116003002', 'A202030001', 'A211030001', 'A231020001', 'A234021001', 'A251020001', 'A273011002', 'A284020001', 'A330010001', 'A369011001', 'A373020001', 'A380020001', 'A420063001', 'A436203001', 'A443064001', 'A543101001', 'A550061001', 'A605102001', 'A673122001', 'A807101001', 'A843101001', 'A850061001', 'A901305050', 'A907105050', 'A926000101', 'A983201001', 'B022001001', 'B109201001', 'B115001001', 'B128201001', 'B134001001', 'B222001001', 'B315002001', 'B403101001', 'B413201001', 'B422431001', 'B460101001', 'B463101001', 'B720000002', 'D020601001', 'E430601001', 'E530021001', 'E540031001', 'E540651001', 'E550572001', 'E639701001', 'F415000101', 'F416000201', 'F439000101', 'F453000101', 'F462000101', 'F467000101', 'F474000102', 'G111041010', 'G600061010', 'H010001001', 'H010002001', 'H020302002', 'H030101001', 'H032103001', 'H050301001', 'H120101001', 'H206201001', 'H207311001', 'H226000201', 'H247301001', 'H305000101', 'H318041010', 'H325041010', 'H332201001', 'H403021010', 'H413041010', 'H416021010', 'H438021010', 'H503331001', 'H504201001', 'H506201001', 'H510203001', 'H512234001', 'H514261001', 'H514262001', 'H517311001', 'H602021010', 'H611061010', 'H612201001', 'H616201001', 'H620101001', 'H622101001', 'H623302001', 'H631302001', 'H640203001', 'H642301001', 'H703301001', 'H740101001', 'H741321001', 'H774201001', 'H774202001', 'I103101001', 'I200101001', 'I202101001', 'I403201001', 'I505301001', 'I532151001', 'J001401001', 'J014401001', 'J032301001', 'J061161001', 'J110301001', 'J111401001', 'J131301001', 'J132401001', 'J151301001', 'J171171001', 'J181301001', 'J202301001', 'J203401001', 'J221311001', 'J223301001', 'J231491001', 'J240401001', 'J251401001', 'J260301001', 'J260541001', 'J261401002', 'J272301001', 'J302401001', 'J320571001', 'J321302002', 'J332302002', 'J340302001', 'J340411001', 'J351401001', 'J383401001', 'J401401001', 'J412442001', 'J421191001', 'J421451001', 'J422401001', 'J451401001', 'J461401001', 'J473401001', 'J480301001', 'J510221001', 'J520211001', 'J570481001', 'J708311001', 'J721401001', 'J735301001', 'J763301001', 'J782401001', 'J783301020', 'J795301020', 'J797301001', 'J813301001', 'J843301002', 'J863241001', 'K073322001', 'K075321001', 'K077322001', 'K117321001', 'K128481001', 'K132181010', 'K172421001', 'K191451001', 'K195401001', 'K201082001', 'K207081010', 'K222302001', 'K225401001', 'K251401001', 'K252301001', 'K259301001', 'K265401001', 'K267401001', 'K288401001', 'K315301001', 'K322201001', 'K327301001', 'K409401001', 'K565301001', 'K633252001', 'K731261001', 'K751401001', 'L001061001', 'L031401001', 'L081301001', 'L225301001', 'L401071001', 'L403301001', 'L441171001', 'L465301001', 'L503401001', 'L510181001', 'L513401001', 'L562301001', 'M005061020', 'M011491010', 'M036151010', 'M042151010', 'M042481010', 'M052521010', 'M053501010', 'M065311010', 'M067401010', 'M068061010', 'M104161010', 'M121301010', 'M135401010', 'M153161010', 'M325311010', 'M332301010', 'M334091010', 'M350401010', 'M351401010', 'M360091010', 'M371181010', 'M377181010', 'M383401010', 'M521401020', 'M530001010', 'M601401010', 'M632301010', 'M704401010', 'M711241010', 'N011301010', 'N302401010', 'O023402001', 'O038401001', 'O055401001', 'O062401001', 'O144291002', 'O148432002', 'O149431003', 'O149433001', 'O203401001', 'O301101001', 'O303521001', 'O306401001', 'O308432001', 'O314101001', 'O319401001', 'O375401001', 'O504251002', 'O505501001', 'O509252002', 'O519251003', 'O522401001', 'O528431002', 'O529251001', 'O575402001', 'O596402001', 'O701581001', 'O703501001', 'O723401001', 'O724501001', 'O726501001', 'O787401001', 'O794402002', 'O813352001', 'O825501001', 'O839431001', 'P011501001', 'P021251001', 'P071401001', 'P171291001', 'P323401001', 'P327401001', 'P332251001', 'P361401001', 'P427101001', 'P571501001', 'P608151001', 'P613402001', 'P613402002', 'P638251001', 'P700151001', 'P704151001', 'P801251001', 'P821501001', 'P831252001', 'Q011571001', 'Q022402001', 'Q259331001', 'Q916461001', 'R103001001', 'S222461001', 'U012401001', 'U047401001', 'U061001001', 'U063501001', 'U072401001', 'U092401001', 'U092402001', 'U100401001', 'U104401001', 'U105401001', 'U108401001', 'U110901001', 'U111521001', 'U120401001', 'U122401001', 'U122402001', 'U123502001', 'U201201001', 'U202201001', 'U221502001', 'U222541001', 'U234502001', 'U234504001', 'U272201001', 'U321401001', 'U344502001', 'U462401001', 'U462501001', 'U464401001', 'V101581001', 'V123561001', 'V123741001', 'V125501001', 'V141401001', 'V145431002', 'V146431001', 'V177401001', 'V300561001', 'V301501001', 'V322542002', 'V361401001', 'V401503001', 'V422501001', 'W231401001', 'X001001002', 'X045401001', 'X211401001', 'Y028406001', 'Y320002001', 'Y461502001', 'Y510501001', 'Y902000101', 'Y561501001']

const ModelStepModel = ({
    selectedModel,
    changeModel = () => [],
    changeParams = () => {},
    stationType,
    stationCode = '',
}) => {
    const statModels = compact([{
        selectedModel: 1,
        title: i18n.arima,
        description: i18n.modelArimaDescription,
        img: 'pictures/iaeauModels/arima.png',
        constant: MODEL_TYPES.ARIMA,
        horizon: DEFAULT_HORIZON,
    }, {
        selectedModel: 2,
        title: i18n.omenTrends,
        description: i18n.modelOmenTrendsDescription,
        img: 'pictures/iaeauModels/augures.png',
        constant: MODEL_TYPES.AUGURES,
        horizon: DEFAULT_HORIZON,
    }, (selectedModel.objective === MODEL_OBJECTIVES.ETIAGE) && {
        selectedModel: 3,
        title: i18n.dryingUp,
        description: i18n.modelDryingUpDescription,
        img: 'pictures/iaeauModels/etiage.jpg',
        constant: MODEL_TYPES.TARRI_BRGM,
        horizon: DEFAULT_HORIZON,
    }, stationType === STATION_TYPE_NAME.piezometry && {
        selectedModel: 4,
        title: i18n.weatherNappes,
        description: i18n.modelWeatherNappesDescription,
        img: 'pictures/iaeauModels/meteonappes.png',
        constant: MODEL_TYPES.AUGURES,
        horizon: DEFAULT_HORIZON,
        disabled: !selectedModel.meteoNappesExists,
    }, stationType === STATION_TYPE_NAME.hydrometry && {
        selectedModel: 8,
        title: i18n.cydre,
        description: i18n.modelCydreDescription,
        img: 'pictures/iaeauModels/cydre.png',
        constant: MODEL_TYPES.CYDRE,
        horizon: DEFAULT_HORIZON,
        disabled: !selectedModel.cydreExists,
    }, stationType === STATION_TYPE_NAME.hydrometry && {
        selectedModel: 12,
        title: 'GR4J (90J)',
        description: 'Le modèle du génie rural à 4 paramètres (GR4J) est un modèle de type réservoir développé par l\'INRAE. Ce modèle a été adapté pour réaliser une prévision à 90J.',
        img: 'https://hydrogr.github.io/airGR/fig/logo_airGR_CMJN_square.svg',
        constant: MODEL_TYPES.GR4J_MODEL,
        idScenario: PREDEFINED_MODEL,
        horizon: 90,
    }])

    const predefinedModels = [{
        selectedModel: 5,
        title: i18n.genericIAModel3J,
        description: i18n.modelGenericAIDescription,
        img: 'pictures/iaeauModels/genericModel.png',
        constant: stationType === STATION_TYPE_NAME.piezometry || camelsList.includes(stationCode) ? MODEL_TYPES.CAMELS : MODEL_TYPES.SCIKIT_LEARN_GENERIC,
        idScenario: PREDEFINED_MODEL,
        horizon: 3,
    }, {
        selectedModel: 6,
        title: i18n.genericIAModel14J,
        description: i18n.modelGenericAIDescription,
        img: 'pictures/iaeauModels/genericModel.png',
        constant: stationType === STATION_TYPE_NAME.piezometry || camelsList.includes(stationCode) ? MODEL_TYPES.CAMELS : MODEL_TYPES.SCIKIT_LEARN_GENERIC,
        idScenario: PREDEFINED_MODEL,
        horizon: 14,
    }, {
        selectedModel: 7,
        title: i18n.customisableAIModel,
        description: i18n.modelCustomisableAIDescription,
        img: 'pictures/iaeauModels/genericModel.png',
        constant: MODEL_TYPES.PERCEPTRON,
        horizon: DEFAULT_HORIZON,
        disabled: true,
    }]

    const hiddenModels = [{
        selectedModel: 9,
        title: 'Modèle Climato A3P',
        description: 'Modèle Climato implémenté par Nico utilisant uniquement les débits.',
        img: 'pictures/iaeauModels/genericModel.png',
        constant: MODEL_TYPES.A3P_CLIMATO_MODEL,
        horizon: 180,
    }, {
        selectedModel: 10,
        title: 'Modèle LSTM Superficiel',
        description: 'Modèle IA LSTM implémenté par l UGE, utilisant Pluie, température, ETP et débits',
        img: 'pictures/iaeauModels/genericModel.png',
        constant: MODEL_TYPES.LSTM_SUP_MODEL,
        idScenario: PREDEFINED_MODEL,
        horizon: 180,
    }, {
        selectedModel: 11,
        title: 'Modèle LSTM Souterrain',
        description: 'Modèle IA LSTM implémenté par l UGE, utilisant Pluie, neige, SWI, drainage, ETP et hauteur NGF',
        img: 'pictures/iaeauModels/genericModel.png',
        constant: MODEL_TYPES.LSTM_SOUT_MODEL,
        idScenario: PREDEFINED_MODEL,
        horizon: 180,
    }]

    useEffect(() => {
        if (selectedModel.typeModel === MODEL_TYPES.METEO_NAPPES) {
            changeParams({ ...DEFAULT_METEO_NAPPE_PARAMS, nbDaysCalculation: selectedModel.horizon })
        }
        if (selectedModel.typeModel === MODEL_TYPES.ARIMA) {
            changeParams({
                ...DEFAULT_ARIMA_PARAMS,
                measureGroupMode: selectedModel.objective === MODEL_OBJECTIVES.CRUE ? 'MAX': (
                    selectedModel.objective === MODEL_OBJECTIVES.ETIAGE ? 'MIN' : 'AVERAGE'
                ),
            })
        }
        if (selectedModel.typeModel === MODEL_TYPES.AUGURES) {
            changeParams(DEFAULT_AUGURE_PARAMS)
        }
        if (selectedModel.typeModel === MODEL_TYPES.TARRI_BRGM) {
            changeParams(DEFAULT_TARRI_PARAMS)
        }
        if (selectedModel.typeModel === MODEL_TYPES.SCIKIT_LEARN_GENERIC || selectedModel.typeModel === MODEL_TYPES.GR4J_MODEL) {
            changeParams(DEFAULT_SCIKIT_PARAMS)
        }
    }, [selectedModel.selectedModel])

    const theme = useTheme()

    const isMediumScreen = useMediaQuery(theme.breakpoints.down('xl'))

    const [nbClickTitle, setNbClickTitle] = useState(0)

    return (
        <Grid container size={12} rowSpacing={1} onClick={() => setNbClickTitle(nbClickTitle+1)}>
            <Grid size={12} sx={{ textAlign: 'center' }}>
                <h5>{i18n.chooseYourModel}</h5>
            </Grid>
            <Grid size={12} sx={{ paddingLeft: '8px' }}>
                <Typography variant='h5' component='p'>
                    {i18n.statisticalModels}
                </Typography>
            </Grid>
            <Grid size={12} sx={{ overflow: 'auto hidden', padding: '8px' }}>
                <Stack
                    direction='row'
                    spacing={2}
                    alignItems='flex-start'
                    sx={{
                        width: 'max-content',
                    }}
                >
                    {statModels.map(m => (
                        <ImageCard
                            key={`Model_${m.title}`}
                            img={m.img}
                            alt={`Image du model ${m.title}`}
                            title={m.title}
                            description={m.description}
                            maxWidth={isMediumScreen ? '25vw' : '18vw'}
                            imgHeight={140}
                            active={selectedModel.selectedModel === m.selectedModel}
                            onClick={() => changeModel({
                                typeModel: m.constant,
                                horizon: m.horizon,
                                idScenario: m.idScenario,
                                statusCode: MODEL_STATUS.DEMAND_SENT,
                                selectedModel: m.selectedModel,
                            })}
                            disabled={m.disabled}
                        />
                    ))}
                </Stack>
            </Grid>
            <Grid size={12} sx={{ padding: '8px 0 0 8px' }}>
                <Typography variant='h5' component='p'>
                    {i18n.aiModels}
                </Typography>
            </Grid>
            <Grid size={12} sx={{ overflow: 'auto hidden', padding: '8px' }}>
                <Stack
                    direction='row'
                    spacing={2}
                    alignItems='flex-start'
                    sx={{
                        width: 'max-content',
                    }}
                >
                    {predefinedModels.map(m => (
                        <ImageCard
                            key={`Model_${m.title}`}
                            img={m.img}
                            alt={`Image du model ${m.title}`}
                            title={m.title}
                            description={m.description}
                            maxWidth={isMediumScreen ? '25vw' : '18vw'}
                            imgHeight={140}
                            active={selectedModel.selectedModel === m.selectedModel}
                            onClick={() => changeModel({
                                typeModel: m.constant,
                                horizon: m.horizon,
                                idScenario: m.idScenario,
                                statusCode: MODEL_STATUS.DEMAND_SENT,
                                selectedModel: m.selectedModel,
                            })}
                            disabled={m.disabled}
                        />
                    ))}
                </Stack>
            </Grid>
            {
                nbClickTitle >= 5 && (
                    <>
                        <Grid size={12} sx={{ padding: '8px 0 0 8px' }}>
                            <Typography variant='h5' component='p'>
                                Modèles cachés
                            </Typography>
                        </Grid>
                        <Grid size={12} sx={{ overflow: 'auto hidden', padding: '8px' }}>
                            <Stack
                                direction='row'
                                spacing={2}
                                alignItems='flex-start'
                                sx={{
                                    width: 'max-content',
                                }}
                            >
                                {hiddenModels.map(m => (
                                    <ImageCard
                                        key={`Model_${m.title}`}
                                        img={m.img}
                                        alt={`Image du model ${m.title}`}
                                        title={m.title}
                                        description={m.description}
                                        maxWidth={isMediumScreen ? '25vw' : '18vw'}
                                        imgHeight={140}
                                        active={selectedModel.selectedModel === m.selectedModel}
                                        onClick={() => changeModel({
                                            typeModel: m.constant,
                                            horizon: m.horizon,
                                            idScenario: m.idScenario,
                                            statusCode: MODEL_STATUS.DEMAND_SENT,
                                            selectedModel: m.selectedModel,
                                        })}
                                        disabled={m.disabled}
                                    />
                                ))}
                            </Stack>
                        </Grid>
                    </>
                )
            }
        </Grid>
    )
}

ModelStepModel.propTypes = {
    selectedModel: ShapeIAEauModel,
    changeModel: PropTypes.func,
    changeParams: PropTypes.func,
    stationType: PropTypes.string,
    stationCode: PropTypes.string,
}

export default ModelStepModel